export default {
  CENTRALIZED: 'CENTRALIZED',
  DECENTRALIZED: 'DECENTRALIZED',
  IMPACT: 'IMPACT',
}
